import { render, staticRenderFns } from "./CurriculumComponent.vue?vue&type=template&id=ae856f22"
import script from "./CurriculumComponent.vue?vue&type=script&lang=ts"
export * from "./CurriculumComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports